import React, { useMemo, useState, useEffect } from "react"
import MesacuatroView from "./Mesacuatro";
import MesaseisView from "./Mesaseis";
import MesadosView from "./Mesados";
import MesacerView from "./Mesacer";
import MesadiesView from "./Mesasdies";
import MesascatorceView from "./Mesascatorce";
import MesaExtraView from "./MesaExtra";
import '../mesas.css'
import { useDispatch, useSelector } from "react-redux";
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag";
import { EliminarsilladeMesa } from "utils/CarritoLocalStorang";
import { deleteSillas } from "StoreRedux/Slice/sillasSlice";
import { addSillas } from "StoreRedux/Slice/sillasSlice";
import { AgregarAsiento } from "utils/CarritoLocalStorang";
import { correlativosadd } from "utils/Querypanelsigui";
import SweetAlert from "react-bootstrap-sweetalert";
import { setSpinersli } from "StoreRedux/Slice/SuscritorSlice";
import { TotalSelecion } from "utils/CarritoLocalStorang";
import { setToastes } from "StoreRedux/Slice/ToastSlice";

import { clienteInfo } from "utils/DatosUsuarioLocalStorag"
import MesaochoView from "./Mesasocho";
import { mikroAxios } from "utils/index";
import { data } from "jquery";
import { logWithCallback } from "utilsstile.js/style";
function MesasViews({ text, status, list, setMapa, cedulaPorRegistro = {} }) {
  let useradmin = clienteInfo()
  let nombre = JSON.parse(sessionStorage.getItem("seleccionmapa"))
  let usedispatch = useDispatch();
  const [alert, setAlert] = useState(null)
  const [tooltip, setTooltip] = useState(null)
  let user = getDatosUsuariosLocalStorag()
  const modalshow = useSelector((state) => state.SuscritorSlice.modal)
  var mapath = useSelector((state) => state.mapaLocalSlice.pathmap)

  const listResolved = useMemo(() => {
    const source = Array.isArray(list) ? list : []
    return source.map((item) => {
      const idRegistro =
        item?.id_registraCompra ??
        item?.id_registra_compra ??
        item?.idRegistro ??
        ""
      const cedulaBase = String(item?.cedula || "").trim()
      const cedulaByRegistro = idRegistro ? String(cedulaPorRegistro[String(idRegistro)] || "").trim() : ""
      return {
        ...item,
        id_registraCompra: item?.id_registraCompra ?? item?.id_registra_compra ?? item?.idRegistro ?? "",
        cedula: cedulaBase || cedulaByRegistro,
      }
    })
  }, [list, cedulaPorRegistro])

  const getSeatByCode = (seatCode) => {
    if (!seatCode) return null
    return listResolved.find((f) => String(f?.silla || "") === String(seatCode)) || null
  }

  const moveTooltip = (e) => {
    const seatEl = e?.target?.closest ? e.target.closest(".sillas") : null
    if (!seatEl) {
      setTooltip(null)
      return
    }

    const seatClass = String(seatEl.className || "")
      .split(" ")
      .find((c) => c.includes("-s-"))

    const seat = getSeatByCode(seatClass)
    if (!seat) {
      setTooltip(null)
      return
    }

    const estado = String(seat?.estado || "").toLowerCase()
    if (estado === "disponible" || estado === "none") {
      setTooltip(null)
      return
    }

    setTooltip({
      top: e.clientY + 16,
      left: e.clientX + 16,
      silla: String(seat?.silla || ""),
      estado: String(seat?.estado || ""),
      registro: String(seat?.id_registraCompra || "").trim(),
      cedula: String(seat?.cedula || "").trim(),
    })
  }

  function Estado(e) {
    let randon = sessionStorage.getItem("random") || ""
    let estado = listResolved.find(f => f.silla == e)
    if (!estado) return "disponible"
    if (estado.estado == null || estado.estado == undefined) return "disponible"
    if (estado.cedula != null && estado.cedula != "") {
      if ((estado.cedula == "" || estado.cedula == undefined || estado.cedula == null) && estado.estado.toLowerCase() == "ocupado") return "apartado"
      //if ((estado.cedula != null && estado.cedula != "") && estado.estado.toLowerCase() == "ocupado") return "apartado"
      if (estado.estado.toLowerCase() == "ocupado") return estado.estado.toLowerCase()
      if (user != null && estado.cedula == user.cedula || (estado.cedula == randon && randon != "")) return "seleccionado"

      else return estado.estado.toLowerCase()
      return
    }
    if ((estado.cedula == "" || estado.cedula == undefined || estado.cedula == null) && estado.estado.toLowerCase() == "ocupado") return "apartado"
    else return estado.estado.toLowerCase()
  }
  function MesaEstado(e) {

    if (listResolved.length == 0) {
      return
    }
    let asiento = listResolved.map(function (k) {
      {
        if (k.cedula != "") {
          if (user == undefined) {
            if (k.estado.toLowerCase() == "reservado" && (k.cedula == null || k.cedula == "" || k.cedula == undefined)) return "disponible"
            return k.estado
          }
          if (k.cedula == user.cedula) {
            return ["seleccionado"];
          }
          // if ((k.cedula == "" || k.cedula == undefined || k.cedula == null) && k.estado.toLowerCase() == "ocupado") return "apartado"
          else { return k.estado }
        }
        else return [k.estado]
      }
    });
    const isSeleccion = (currentValue) => currentValue == "seleccionado";
    const isApartado = (currentValue) => currentValue == "apartado";
    const isOcupado = (currentValue) => currentValue == "Ocupado" || currentValue == "OCUPADO";
    const isReserva = (currentValue) => currentValue == "RESERVADO" || currentValue == "reservado";
    const isDispon = (currentValue) => currentValue == "disponible" || currentValue == "DISPONIBLE";
    const isDisnone = (currentValue) => currentValue == "none" || currentValue == "d-none";
    let mesas = ["A", "B", "C", "D"]
    let sillabloquea = ["D42", "D41", "D40", "D38", "D39", "D37", "D36"]
    let envotid = sessionStorage.getItem("eventoid")
    if (Object.values(asiento).every(isOcupado)) { return "mesaocupado" }
    if (Object.values(asiento).every(isReserva)) { return "mesareserva" }
    if (Object.values(asiento).every(isSeleccion)) { return "mesaselecion" }
    if (Object.values(asiento).every(isApartado)) { return "mesaapartada" }
    if (Object.values(asiento).every(isDisnone)) { return "none" }
    return "mesadisponible"
  }
  /*  obtener sillas  */
  function obtenerid(e) {
    const sillaObj = listResolved.find(f => f.silla == e);
    if (!sillaObj) return "";
    let estado = sillaObj.idsilla !== undefined ? "silla-" + sillaObj.idsilla : "";
    return estado;
  }
  function obtenersila(e) {
    let estado = listResolved.find(f => f.silla == e).idsilla != undefined ? "silla-" + listResolved.find(f => f.silla == e).silla + "\n" + listResolved.find(f => f.silla == e).cedula + "\n #" + listResolved.find(f => f.silla == e).idsilla : ""
    return estado
  }
  function sillasid(e) {

    // console.log("%c%s", "color: red; background: yellow; font-size: 24px;", "ADVERTENCIA")
  }
  function enviarsillas(text) {
    logWithCallback(list)
    let dato = listResolved.filter(elm => elm.estado == 'Ocupado' && (elm.cedula == null || elm.cedula == ''))
    let bloque = listResolved.filter(elm => elm.estado != 'none').map(el => {
      if (el.cedula == null || el.cedula == '') {
        return el.idsilla
      }
    }).filter(e => e != undefined)
    let datos = document.getElementById(text).classList.value

    if (bloque.length == 0) return
    succesLimit(bloque, datos, dato)
  }
  const succesLimit = (me, datos, lista) => {
    if (useradmin.perfil == 'suscriptores') return
    logWithCallback({ me, lista })

    const Botoon = () => lista.length > 0 ? <button

      className="btn btn-danger "
      onClick={() => enviarComentario(me, me)}
    >
      Add / modi Comentario
    </button> : ""
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={"Deseas Cambiar el estado de las sillas libres"}
        onConfirm={() => enviarLocalidad('Disponible', me)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Disponible"
        cancelBtnText="Ocupado"
        closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
        showCancel
        customButtons={
          <React.Fragment>
            <button
              className="btn btn-primary"
              onClick={() => hideAlert()}
            >
              Cancelar
            </button>
            <button
              className="btn btn-success"
              onClick={() => enviarLocalidad('Disponible', me)}
            >
              Disponible
            </button>
            <button
              className="btn btn-danger"
              onClick={() => enviarLocalidad('Ocupado', me)}
            >
              Ocupado
            </button>
            <Botoon />

          </React.Fragment>
        }
      >
        {"de la Mesa " + datos.split(" ")[0]}
      </SweetAlert>
    )
  }
  async function enviarComentario(params, Localidades,) {
    if (params.length > 1) {
      $.confirm({
        title: 'Enviar Comentario',
        content: `
    <input type="text" id="comentarioInput" class="form-control" placeholder="Comentario..."><br>
    <button id="actualizarBtn" class="btn btn-primary btn-sm">Actualizar</button>
  `,
        onContentReady: function () {
          const self = this;

          self.$content.find('#actualizarBtn').on('click', function () {
            const comentario = self.$content.find('#comentarioInput').val();
            // Aquí puedes hacer lo que necesites con el comentario, como enviarlo vía AJAX

            $.ajax({
              url: 'https://api.t-ickets.com/mikroti/Boleteria/item_localidad',
              "url": "https://api.t-ickets.com/mikroti/Boleteria/item_localidad",
              "method": "PUT",
              "timeout": 0,
              "headers": {
                "Content-Type": "application/json"
              },
              "data": JSON.stringify({
                "id_localidades": params,
                "estado": comentario,
                "comentario": true
              }),
              success: function (res) {
                $.alert('Comentario enviado correctamente.');
                window.location.reload();
              },
              error: function () {
                $.alert('Error al enviar el comentario.');
              }
            });
          });
        }
      });
      return
    }
    let data = JSON.stringify({
      "id_localidades": Localidades[0],
      "espacio": ""
    });

    var settings = {
      url: "https://api.t-ickets.com/mikroti/Boleteria/itemlocalidad",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json"
      },
      data: data,
    };
    $.confirm({
      title: 'Detalle de mesas',
      content: function () {
        var self = this;

        return $.ajax(settings).done(function (response) {
          if (response.estado) {
            let html = `
              <input type="text" id="comentarioInput" class="form-control" placeholder="Comentario..."><br>
              <button id="actualizarBtn" class="btn btn-primary btn-sm">Actualizar</button>
              <hr>
              <ul>
            `;

            response.localidades.forEach(loc => {
              html += `<li><strong>Silla:</strong> ${loc.silla} &nbsp; <strong>Comentario:</strong> ${loc.id_registraCompra || ''}</li>`;
            });

            html += '</ul>';

            self.setContent(html);
          } else {
            self.setContent('No hay localidades disponibles.');
          }
        }).fail(function () {
          self.setContent('Algo salió mal al obtener los datos.');
        });
      },
      onContentReady: function () {
        const self = this;

        // Aquí el DOM ya está completamente insertado
        self.$content.on('click', '#actualizarBtn', function () {
          const comentario = self.$content.find('#comentarioInput').val();
          $.ajax({
            url: 'https://api.t-ickets.com/mikroti/Boleteria/item_localidad',
            method: 'PUT',
            timeout: 0,
            headers: {
              "Content-Type": "application/json"
            },
            data: JSON.stringify({
              id_localidades: Localidades[0],
              estado: comentario,
              comentario: true
            }),
            success: function (res) {
              $.alert('Comentario enviado correctamente.');
              window.location.reload();
            },
            error: function () {
              $.alert('Error al enviar el comentario.');
            }
          });
        });
      }
    });



  }
  async function enviarLocalidad(estado, Localidades) {
    try {
      let { data } = await mikroAxios.put('/Boleteria/item_localidad', {


        "id_localidades": Localidades,
        "estado": estado

      })
      hideAlert()
      setMapa()
    } catch (error) {
      logWithCallback(data)
    }


  }
  const succesSilla = (e) => {
    let dato = e.length == 1 ? e[0].idsilla : e
    if (useradmin.perfil == 'suscriptores') return
    let datos = listResolved.find(f => f.silla == e)
    if (!datos) return
    if (datos.estado == 'none') return
    if (datos.cedula == null || datos.cedula == "" || datos.cedula == undefined) {
      let estado = datos.estado == "Ocupado" ? 'Disponible' : 'Ocupado'
      logWithCallback([datos])
      let me = [datos.idsilla]
      const Botoon = () => datos.estado == "Ocupado" ? <button

        className="btn btn-danger "
        onClick={() => enviarComentario(datos, me)}
      >
        Ver Comentario
      </button> : ""
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={"Deseas Cambiar el estado "}
          onConfirm={() => enviarLocalidad("" + estado, me)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Si, Continuar"
          cancelBtnText="Cancelar"
          closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
          customButtons={
            <React.Fragment>
              <button
                className="btn btn-primary"
                onClick={() => hideAlert()}
              >
                Cancelar
              </button>
              <button
                className="btn btn-success"
                onClick={() => enviarLocalidad("" + estado, me)}
              >
                Si, Continuar
              </button>
              <Botoon />
            </React.Fragment>
          }
          showCancel>
          {"la sillas " + e + " por " + estado}
        </SweetAlert>)
    }
  }
  const hideAlert = () => setAlert(null)
  return (
    <div onMouseMove={moveTooltip} onMouseLeave={() => setTooltip(null)}>
      {(() => {
        switch (status) {
          case 2:
            return <MesadosView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)} />;
          case 4:
            return <MesacuatroView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)} />;
          case 6:
            return <MesaseisView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)}
            />;
          case 8:
            return <MesaochoView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)} />;
          case 10:
            return <MesadiesView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)} />;
          case 11:
            return <MesadiesView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)}

            />;
          case 12:
            return <MesadiesView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)}
            />;
          case 13:
          case 14:
            return <MesascatorceView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)}
            />;
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
            return <MesaExtraView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)}
            />;
          default:
            return <MesacerView text={text} list={listResolved}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alert}
              enviarsillas={() => enviarsillas(text)} />;
        }
      })()}
      {tooltip && (
        <div
          id="tooltip-mesa"
          style={{
            position: "fixed",
            top: `${tooltip.top}px`,
            left: `${tooltip.left}px`,
            width: "200px",
            background: "white",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            zIndex: 4000,
            padding: "8px",
            pointerEvents: "none",
          }}
        >
          <div className="text-center border-bottom pb-1 mb-1">
            <strong>Mesa/Silla: {tooltip.silla}</strong>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-start">
            <p className="m-0"><b>Estado:</b> {tooltip.estado || "-"}</p>
            <p className="m-0"><b>Registro:</b> {tooltip.registro || "Sin registro"}</p>
            <p className="m-0"><b>User:</b> {tooltip.cedula || "Sin cedula"}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default MesasViews